import { useSelector, TypedUseSelectorHook } from "react-redux";
import { RootReducer } from "../redux/reducers";

/**
 * typed alternative to useSelector
 */
const useTypedSelector: TypedUseSelectorHook<RootReducer> = useSelector;

export default useTypedSelector;